// Published support address. Keep in sync with the backend SUPPORT_EMAIL env var.
export const SUPPORT_EMAIL = 'support@jyto.eu';

export const COUNTRIES = [
  'Austria','Belgium','Bulgaria','Croatia','Cyprus','Czech Republic','Denmark',
  'Estonia','Finland','France','Germany','Greece','Hungary','Ireland','Italy',
  'Latvia','Lithuania','Luxembourg','Malta','Netherlands','Poland','Portugal',
  'Romania','Slovakia','Slovenia','Spain','Sweden','Norway','Switzerland',
  'United Kingdom','Other',
];

// (SECTORS removed 2026-07-19 — the homemade sector field is gone from
// profiles/matching; CPV categories carry the domain in official vocabulary.)

export const SIZES = ['1-10', '11-50', '51-200', '201-500', '500+'];

// Contract-size capacity bands — MUST match the backend tender contract_size_band
// vocabulary (ingestion/fetcher.py _size_band) so the verdict prompt can align
// a profile's capacity against each tender's band. Empty value = "no preference".
export const CONTRACT_SIZE_OPTIONS = [
  { value: '', label: 'Any size' },
  { value: 'small', label: 'Small (< €50k)' },
  { value: 'medium', label: 'Medium (€50k–€500k)' },
  { value: 'large', label: 'Large (€500k–€5M)' },
  { value: 'xlarge', label: 'Very large (> €5M)' },
];

export const COUNTRY_ISO = [
  { code: 'AUT', name: 'Austria' },
  { code: 'BEL', name: 'Belgium' },
  { code: 'BGR', name: 'Bulgaria' },
  { code: 'HRV', name: 'Croatia' },
  { code: 'CYP', name: 'Cyprus' },
  { code: 'CZE', name: 'Czech Republic' },
  { code: 'DNK', name: 'Denmark' },
  { code: 'EST', name: 'Estonia' },
  { code: 'FIN', name: 'Finland' },
  { code: 'FRA', name: 'France' },
  { code: 'DEU', name: 'Germany' },
  { code: 'GRC', name: 'Greece' },
  { code: 'HUN', name: 'Hungary' },
  { code: 'IRL', name: 'Ireland' },
  { code: 'ITA', name: 'Italy' },
  { code: 'LVA', name: 'Latvia' },
  { code: 'LTU', name: 'Lithuania' },
  { code: 'LUX', name: 'Luxembourg' },
  { code: 'MLT', name: 'Malta' },
  { code: 'NLD', name: 'Netherlands' },
  { code: 'POL', name: 'Poland' },
  { code: 'PRT', name: 'Portugal' },
  { code: 'ROU', name: 'Romania' },
  { code: 'SVK', name: 'Slovakia' },
  { code: 'SVN', name: 'Slovenia' },
  { code: 'ESP', name: 'Spain' },
  { code: 'SWE', name: 'Sweden' },
  { code: 'NOR', name: 'Norway' },
  { code: 'CHE', name: 'Switzerland' },
  { code: 'GBR', name: 'United Kingdom' },
];

export const CPV_DIVISIONS = [
  { code: '72', label: 'IT services' },
  { code: '48', label: 'Software packages' },
  { code: '73', label: 'Research & development' },
  { code: '71', label: 'Architecture & engineering' },
  { code: '45', label: 'Construction works' },
  { code: '44', label: 'Construction materials' },
  { code: '33', label: 'Medical equipment' },
  { code: '85', label: 'Health & social work' },
  { code: '80', label: 'Education & training' },
  { code: '79', label: 'Business services' },
  { code: '66', label: 'Financial services' },
  { code: '75', label: 'Public administration' },
  { code: '50', label: 'Repair & maintenance' },
  { code: '60', label: 'Transport services' },
  { code: '63', label: 'Logistics & cargo' },
  { code: '90', label: 'Environmental services' },
  { code: '32', label: 'Communications equipment' },
  { code: '35', label: 'Security & defence' },
  { code: '64', label: 'Postal & telecom' },
  { code: '65', label: 'Public utilities' },
  { code: '70', label: 'Real estate' },
  { code: '92', label: 'Cultural & recreational' },
  { code: '34', label: 'Transport equipment' },
  { code: '38', label: 'Laboratory equipment' },
  { code: '24', label: 'Chemical products' },
  { code: '15', label: 'Food & beverages' },
];

// (Working-languages constants + LanguageSelect were removed 2026-07-19 —
// languages are out of matching entirely; see company_fields_simplification.)

export const PROCUREMENT_TYPE_OPTIONS = [
  'Consulting / advisory',
  'Software development',
  'Hardware / supply',
  'Maintenance & support',
  'Training & education',
  'Works / construction',
];

export const LS_KEYS = {
  token: 'tm_token',
  userId: 'tm_user_id',
  email: 'tm_email',
  isAdmin: 'tm_is_admin',
  savedTenders: 'tm_saved_tenders',
  activeProfileId: 'tm_active_profile_id',
};
